import { InputBase } from '@mui/material';
import React, { useState } from 'react';

import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Icons } from '../../../components/icons';
import { useTranslate } from '../../../hooks';
import classNames from 'classnames';

const SearchB = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #0000001f',
  //width: "200px",
  marginLeft: 0,
  height: '40px',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(0),
    //width: "283px",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: '#081735',
  //width: "200px",
  height: '38px',
  //backgroundColor: "#E6E8F0",
  font: 'normal normal normal 14px/20px',
  letterSpacing: '0px',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(3)})`,
    transition: theme.transitions.create('width'),
    //width: "200px",
    [theme.breakpoints.up('sm')]: {
      //width: "200px",
      '&:focus': {
        //width: "200px"
      },
    },
  },
}));

const HrSearchComponents = (props) => {
  const { t } = useTranslation();
  const [val, setVal] = useState('');

  const handleSearch = (e) => {
    setVal(e.target.value);
    props.onChange(e.target.value);
  };

  const { isRTL } = useTranslate();

  return (
    <>
      <SearchB>
        <Icons
          name="search"
          width={17}
          height={17}
          viewBox={[20, 20]}
          className={classNames('absolute text-gray-300 top-2.5', {
            'left-2': !isRTL,
            'right-2': isRTL,
          })}
        />
        <StyledInputBase
          onChange={handleSearch}
          value={props.value ? props.value : val}
          placeholder={props.search || t('Search here...')}
          inputProps={{ 'aria-label': 'search' }}
          style={{
            width: props.width,
            alignContent: 'center',
          }}
        />
      </SearchB>
    </>
  );
};
export default HrSearchComponents;
